<!-- 生态圈目标签订 列表 SQM -->

<template>
  <h-list-page class="ecologyTargetSignedList_style">
    <h-card :title="h_i18n('13fe8d8c74cb94357d8e105686778dfe')" width="100%" footer is-search is-open @change-method="changeMethod">
      <h-area>
        <h-search class="searchColItem" :title="h_i18n('3c092f8c2f02bb3868b167e04275403f')">
          <h-select v-model="searchData.sqeNode" :placeholder="h_i18n('708c9d6d2ad108ab2c560530810deae9')" clearable filterable @change="changeNull(searchData.sqeNode, 'sqeNode')">
            <h-option v-for="item in data.sqeNodeList" :key="item.sqeNode" :label="item.sqeNode" :value="item.sqeNode"></h-option>
          </h-select>
        </h-search>
        <h-search class="searchColItem" :title="h_i18n('d9c8ae7c4e67140d3921659fa8664592')">
          <h-select v-model="searchData.ecosphere" clearable filterable @change="changeNull(searchData.ecosphere, 'ecosphere')">
            <h-option v-for="item in data.ecosphereList" :key="item.ecosphere" :label="item.ecosphere" :value="item.ecosphere">
            </h-option>
          </h-select>
        </h-search>
        <!-- <h-search class="searchColItem" title="供应商代码">
          <h-autocomplete popper-class="planHidden" v-model="searchData.supplyCode" :fetch-suggestions="supplyCodeChange"
            :trigger-on-focus="false" @input="() =>
                searchData.supplyCode.length < 2
                  ? (plan.showSupplyPlan = false)
                  : ''
              " @clear="plan.showSupplyPlan = false" clearable placeholder="请输入至少两位供应商代码"
            @blur="detailBlur('showSupplyPlan')" @focus="detailFocus('showSupplyPlan')">
          </h-autocomplete>
          <h-detail width="400px" top="34px" left="0">
            <el-table v-show="plan.showSupplyPlan" v-loading="data.supplyLoading" :data="data.supplyCodeList" border
              size="small" max-height="252" @row-click="clickSupplierCode" @mousedown="plan.planBlur = true">
              <el-table-column prop="supplyCode" label="供应商代码" width="120"></el-table-column>
              <el-table-column prop="supplyName" label="供应商名称"></el-table-column>
            </el-table>
            <div v-if="plan.showSupplyPlan && plan.SupplyOver600" style="
                color: red;
                height: 20px;
                background-color: #fff;
                padding-top: 3px;
              ">
              <span style="padding-left: 10px; font-size: 12px">注：仅查询600条数据，如无所需结果，请输入更精确的供应商代码</span>
            </div>
          </h-detail>
        </h-search>
        <h-search class="searchColItem" title="供应商名称">
          <h-input v-model="searchData.supplyName" clearable @change="changeNull(searchData.supplyName, 'supplyName')">
          </h-input>
        </h-search> -->

        <!-- <h-search class="searchColItem" title="大产业线">
          <h-select  class="search-input" placeholder="请选择大产业线" v-model="searchData.plId" clearable>
             <h-option v-for="item in data.classList" :key="item.valueId" :label="item.valueName" :value="item.valueId">
             </h-option>
          </h-select>
        </h-search> -->
        <h-search class="searchColItem" :title="h_i18n('67fb0c01996aad4f78e72afa21aee6c3')">
          <h-select v-model="searchData.goalStatus" clearable filterable @change="changeNull(searchData.goalStatus, 'goalStatus')">
            <h-option :label="h_i18n('dbcbdf8c0275289b5fc8daa9dd6cde29')" value="2391"></h-option>
            <h-option :label="h_i18n('9922cfc73a496def77e16c70b221dad7')" value="2392"></h-option>
            <h-option :label="h_i18n('7618bb607a6aa59e9b427020af667f45')" value="2393"></h-option>
            <h-option :label="h_i18n('3116b821b9b7b3dc5743c8d048b2c066')" value="2394"></h-option>
            <h-option :label="h_i18n('f8685b8039e4ee20d144107fdbbb8241')" value="2395"></h-option>
            <h-option :label="h_i18n('2cd910ee2d89f790872edde1eadd6277')" value="2396"></h-option>
          </h-select>
        </h-search>

        <h-search class="searchColItem" :title="h_i18n('9dfd1938d29d57fd38b6ff28b66f1688')">
          <h-date-picker v-model="searchTemp.year" type="year" format="YYYY"
                         @change="clearAll()"></h-date-picker>
        </h-search>

        <template #operate>
          <h-button type="primary" :loading="data.tableLoading" @click="getInfo(true)" size="middle">
            <template #icon>
              <search />
            </template>{{ h_i18n('bee912d79eefb7335988c4997aa9138d') }}</h-button>
        </template>

      </h-area>
    </h-card>
    <h-table-card :title="h_i18n('c3d7d98d03ef74edd22fbc72848f3a23')" :is-left="0" :h-data="data.dataOfTable">
      <template #buttonGroup>
        <h-button-group>
          <!-- 目标签订 按钮 -->
          <template v-for="item in data.btnListOfSqm" :key="item.code">
            <template v-for="temp in data.btnCodeList" :key="temp">
              <h-button v-if="item.code.includes(temp)" type="primary"
               :loading="loadingFunction(temp)" @click="btnFunction(temp)">
                <export v-if="temp == 'mkhl_STQmbqd_mbqd_DC'"/>
                <analysis v-if="temp == 'mkhl_STQmbqd_mbqd_MBQD'"/>
                {{ item.name }}</h-button>
            </template>
          </template>
        </h-button-group>
      </template>
      <el-table :empty-text="h_i18n('8fd727180609a8164afad4b5eecc5544')" class="forPic_table_style" v-loading="data.tableLoading" height="540" @selection-change="listCheckBoxChange"
      border :data="data.dataOfTable" size="small" style="width: 100%; min-height: 540px">
        <el-table-column type="selection" width="40"></el-table-column>
        <el-table-column type="index" :label="h_i18n('faaadc447b1c2b1adc920d9c9aedcc25')" width="40"></el-table-column>
        <el-table-column prop="goalCode" :label="h_i18n('42cb6a16f276fd9d3ee165e9a3cfa26d')" width="200">
          <template #default="{ row }">
            <span style="text-decoration: none;color:#165DFF; cursor: pointer;" @click="gotoTargetView(row)">{{ row.goalCode }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="year" :label="h_i18n('9dfd1938d29d57fd38b6ff28b66f1688')" width="50"></el-table-column>
        <!-- <el-table-column prop="className" label="大产业线" width="100"></el-table-column> -->
        <el-table-column prop="sqeNode" :label="h_i18n('3c092f8c2f02bb3868b167e04275403f')" min-width="100"></el-table-column>
        <el-table-column prop="supplyCode" :label="h_i18n('1b7ecd2bdbd8a1a112dead57724f06df')" width="90"></el-table-column>
        <el-table-column prop="supplyName" :label="h_i18n('9190cc22c9ba377113bc54ac51013a0b')" width="200" align="left"></el-table-column>
        <el-table-column prop="ecosphere" :label="h_i18n('d9c8ae7c4e67140d3921659fa8664592')" min-width="100"></el-table-column>
        <!-- <el-table-column prop="" label="签订类型" width="100"></el-table-column> -->
        <el-table-column prop="goalStatus" :label="h_i18n('67fb0c01996aad4f78e72afa21aee6c3')" width="100">
          <template #default="{row}">
            <span v-if="row.goalStatus == '2391'">{{ h_i18n('dbcbdf8c0275289b5fc8daa9dd6cde29') }}</span>
            <span v-else-if="row.goalStatus == '2392'">{{ h_i18n('9922cfc73a496def77e16c70b221dad7') }}</span>
            <span v-else-if="row.goalStatus == '2393'">{{ h_i18n('7618bb607a6aa59e9b427020af667f45') }}</span>
            <span v-else-if="row.goalStatus == '2394'">{{ h_i18n('3116b821b9b7b3dc5743c8d048b2c066') }}</span>
            <span v-else-if="row.goalStatus == '2395'">{{ h_i18n('f8685b8039e4ee20d144107fdbbb8241') }}</span>
            <span v-else-if="row.goalStatus == '2396'">{{ h_i18n('2cd910ee2d89f790872edde1eadd6277') }}</span>
            <span v-else></span>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="" label="创建人" width="80"></el-table-column> -->
        <el-table-column prop="createTime" :label="h_i18n('eca37cb0726c51702f70c486c1c38cf3')" width="170">
          <template #default="{ row }">
            <span>{{ time(row.createTime, 6) }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="" label="更新人" width="80"></el-table-column> -->
        <el-table-column prop="updateTime" :label="h_i18n('a001a226fdc34fd7121f9c4839c759a2')" width="170">
          <template #default="{ row }">
            <span>{{ time(row.updateTime, 6) }}</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background @size-change="handleSizeChange" @current-change="getInfo"
        v-model:currentPage="searchData.pageNo" :page-size="10" layout="total, prev, pager, next,jumper"
        :total="data.total">
      </el-pagination>
    </h-table-card>

  </h-list-page>
</template>



<script setup>
//Automatic script writing.
import h_i18n from '@/utils/Internationalization';

import {reactive,getCurrentInstance,onMounted,ref,nextTick,onActivated,onDeactivated,} from "vue";
import { useRoute } from "vue-router";
import axios from "axios";
const { proxy, ctx } = getCurrentInstance();
const route = useRoute();
const searchData = reactive({
  supplyCode: "",
  mtlNo: "",
  pageNo: 1,
  pageSize: 10,
});
const data = reactive({
  tableLoading:false,
  analysisBtnLoading:false,
  exportLoading:false,
  keepalivestatus:0,
  btnCodeList:[
    "mkhl_STQmbqd_mbqd_DC","mkhl_STQmbqd_mbqd_MBQD"
  ],
  btnListOfSqm:[],
})

const searchTemp = reactive({})

/**
 * 传高度
 */
const changeMethod = () => {
  proxy.postThisPageHeight();
};
/**
 * 勾选操作
 * @param {*} rowArr 选中行
 */
const listCheckBoxChange = (rowArr) => {
  data.clickRowList = rowArr
};
// 按钮事件
const btnFunction = (btnCode) => {
  switch(btnCode){
  case "mkhl_STQmbqd_mbqd_DC": // 导出
  excleBtn()
    break;
    case "mkhl_STQmbqd_mbqd_MBQD": // 目标签订
    analysisBtn()
    break;

  }
}
// loading事件
const loadingFunction = (btnCode) => {
  switch(btnCode){
  case "mkhl_STQmbqd_mbqd_DC":
    return data.exportLoading
    case "mkhl_STQmbqd_mbqd_MBQD":
    return data.analysisBtnLoading

  }
}
// 清除按钮事件
const searchClear = (key) => {
  searchData[key] = undefined;
};
// input为空时undefined
const changeNull = (value, key) => {
  if (value === "") {
    searchData[key] = undefined;
  }
};
/**
 * 年月 空检验
 */
 const clearAll = (flag) => {
  if (!searchTemp.year) {
    // !flag && proxy.$message({
    //   message: '年 不允许为空',
    //   type: 'warning',
    // })
    searchData.year = undefined
  } else {
    date(searchTemp.year, "year");
  }
  if (!searchTemp.month) {
    // !flag && proxy.$message({
    //   message: '月 不允许为空',
    //   type: 'warning',
    // })
    searchData.month = undefined
  } else {
    date(searchTemp.month, "month");
  }
}
/**
 * 上传前时间处理,转录
 * @param year 年
 * @param month 月
 */
 const date = (date, type) => {
  if (type === "year") {
    searchData.year = new Date(date).getFullYear();
  } else if (type === "month") {
    searchData.month =
      new Date(date).getMonth() + 1 < 10
        ? new Date(date).getMonth() + 1
        : new Date(date).getMonth() + 1;
  }
}
const http = reactive({
  mtlSearchHttp: false,
  supplySearchHttp: false,
});
const plan = reactive({
  showMtlPlan: false,
  planBlur: false,
  showSupplyPlan: false,
  MtlOver600: false,
  SupplyOver600: false,
});

// 弹窗失焦
const detailBlur = (v) => {
  if (!plan.planBlur) {
    plan[v] = false;
  }
};
// 弹窗聚焦
const detailFocus = (v) => {
  plan.planBlur = false;
  if (v == "showSupplyPlan") {
    if (searchData.supplyCode.length >= 2) {
      plan[v] = true;
    }
  } else if (v == "showMtlPlan") {
    if (searchData.mtlNo.length >= 4) {
      plan[v] = true;
    }
  }
};
const clickMtlNo = (row) => {
  searchData.mtlNo = row.mtlNo;
  plan.showMtlPlan = false;
};

const clickSupplierCode = (row) => {
  searchData.supplyCode = row.supplyCode;
  plan.showSupplyPlan = false;
};
/**
 * 专用号模糊查询
 */
const mtlNoChange = () => {
  plan.planBlur = false;
  if (http.mtlSearchHttp) http.mtlSearchHttp.cancel();
  http.mtlSearchHttp = axios.CancelToken.source();
  if (searchData.mtlNo.length < 4) {
    plan.showMtlPlan = false;
  } else {
    plan.showMtlPlan = true;
    data.mtlLoading = true;
    proxy
      .$http({
        method: "POST",
        url: "/base/basicData/searchMaterielList",
        headers: { "content-type": "application/json" },
        data: {
          mtlNo: searchData.mtlNo,
        },
        cancelToken: http.mtlSearchHttp.token,
      })
      .then((res) => {
        data.mtlNoList = res.data.data;
        if (data.mtlNoList.length >= 600) {
          plan.MtlOver600 = true;
          data.mtlLoading = false;
        } else {
          plan.MtlOver600 = false;
          data.mtlLoading = false;
        }
      })
      .catch((e) => { });
  }
};

// sqe节点列表 
const getSqeNodeList = () => {
  proxy.$http({
    url: '/base/ecosphere/sqeEcosphereList',
    method: 'post',
    data: {
      pageNo:1,
      pageSize:99999,
      createTime: undefined,
      updateTime: undefined,
    }
  }).then(res => {
    if (res.data.code == 200) {
      let sqeNodeListTemp = res.data.data.records.map(item=>{
        return {sqeNode:item.sqeNode}
      })
      data.sqeNodeList = sqeNodeListTemp.filter((obj, index, self) =>
        index === self.findIndex((t) => (
          t.sqeNode === obj.sqeNode
        ))
      )
    } else {

    }
  })
  .catch(err => {

  })
  .finally(() => {
  })
}
// 生态圈列表
const getEcoList = () => {
  proxy.$http({
    url: '/base/ecosphere/ecosphereList',
    method: 'post',
    data: {
      pageNo:1,
      pageSize:99999,
      createTime: undefined,
      updateTime: undefined,
    }
  })
  .then((res) => {
    if(res.data.code == 200){
      data.ecosphereList = res.data.data.records.map(item=>{
        return {ecosphere:item.ecosphere,id:item.id}
      })
    }else{
    }
  })
  .catch((err) => {
  })
  .finally(() => {
  });
}
// 获取大产业线
const getClassCodeList = () => {
  proxy
    .$http({
      method: 'post',
      url: `/base/inspcard/getClassHac?name=${route.query.name}`
    })
    .then(res => {
      if (res.data.data.length > 0) {
        data.classList = res.data.data
      } else {
        data.classList = []
      }
    })
    .catch(err => {
      proxy.error(h_i18n('f0b60bbac29555e46c0ad6c6452d13ba') + err)
    })
    .finally(() => {})
}
// 查询
const getInfo = (flag) => {
  if (true == flag) {
    searchData.pageNo = 1;
  }
  data.tableLoading = true;
  proxy
    .$http({
      url: "/base/ecosphere/goalList",
      method: "post",
      data: {
        ...searchData,
        mtlNo: searchData.mtlNo ? searchData.mtlNo : undefined,
        supplyCode: data.supplyCode,
        insertDate: undefined,
        identifyDate: undefined,
        name: data.supplyCode,
        nickName: data.supplyName,
      },
    })
    .then((res) => {
      if (res.data.code === "200") {
        // data.sybAllList =
        //   data.sybAllList.length > 0 ? data.sybAllList : res.data.data.sybList;
        // data.categoryList =
        //   data.categoryList.length > 0
        //     ? data.categoryList
        //     : res.data.data.categoryList;
        data.dataOfTable = res.data.data.records;

        data.total = res.data.data.total;
        data.tableLoading = false;
      } else {
        proxy.warning({ message: res.data.msg, title: h_i18n('acd5cb847a4aff235c9a01ddeb6f9770') });
        data.tableLoading = false;
      }
    })
    .catch((err) => {
      proxy.warning({ message: err, title: h_i18n('acd5cb847a4aff235c9a01ddeb6f9770') });
      data.tableLoading = false;
    });
};
// 导出
const excleBtn = () => {
  if (data.total > 5000) {
        proxy.warning(
          { message: h_i18n('748c802d8fe36ada78520df791295747'), title: h_i18n('f148292ae0c683ca6fe4246350d309f6') },
          {
            confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
            callback: (action) => { },
          }
        );
        return;
      }
      data.exportLoading = true;
      proxy.startLoading(h_i18n('54daf15f5c072252ea615ae23cb6d0d1'));
      proxy.httpFile({
          method: "post",
          url: "/base/ecosphere/exportSqmGoal",
          data: {
            ...searchData,
            mtlNo: searchData.mtlNo ? searchData.mtlNo : undefined,
            supplyCode: data.supplyCode,
            insertDate: undefined,
            identifyDate: undefined,
            pageSize: undefined,
            pageNo: undefined,
            fixConfig:true,
            searchFlag:'sqm',
            name: data.supplyCode,
            nickName: data.supplyName,
          },
        },
        h_i18n('2362edd4a72a1ff92a1b1a969cfd5ba5')
      ).then(res=>{
        data.exportLoading = false;
      }).catch(err=>{
        data.exportLoading = false;
        proxy.closeLoading()
      })
};
// 目标查看
const gotoTargetView = (row) => {
  proxy.$router.push({
    name:'targetView',
    query: {
      supplyCode: data.supplyCode,
      supplyName: data.supplyName,
      trueName: data.trueName,
      userName: data.userName,
      dataFrom: 'sqm',
      id:row.id,
    }
  })
}
// 目标签订
const analysisBtn = () => {
  if(!data.clickRowList || data.clickRowList.length != 1){
    proxy.info(h_i18n('0c70a7c7f5b39e1841d51264db61d10f'))
    return
  }
  if(data.clickRowList[0].year != new Date().getFullYear()){
    proxy.info(h_i18n('8554065734223af80a40d4064a8e5575'))
    return
  }
  if(data.clickRowList[0].goalStatus != 2392){
    proxy.info(h_i18n('be596196e1e56e8742c25b4386790322'))
    return
  }
  proxy.$router.push({
    name:'targetSignedSub',
    query: {
      supplyCode: data.supplyCode,
      supplyName: data.supplyName,
      trueName: data.trueName,
      userName: data.userName,
      dataFrom: 'sqm',
      id:data.clickRowList[0].id
    }
  })
}
onMounted(() => {
  if (route.query) {
    data.supplyCode = route.query.supplyCode;
    data.supplyName = route.query.supplyName;
    data.trueName = route.query.trueName
    data.userName =  route.query.userName

    if(!route.query.supplyCode){
      proxy.info({title: h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'), message: h_i18n('c0f92e28b64a4268408f10aa60dc47c8'),confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
        callback: (action) => {
          proxy.$router.back()
        },})
      return
    }
  }
  if(route.query.dataFrom != 'sqm'){
    proxy.$router.replace('/404')
    return
  }
  // sqm按钮权限
  if(route.query.parentId && route.query.parentId != 'null' && route.query.parentId != 'undefined' && route.query.parentId != ''){
    let p = proxy.getButtonFromSqm(route.query.parentId,route.query.roleCode)
    p.then(res=>{
      if(res.length > 0){
        data.btnListOfSqm = res
      }
    })
  }else{
    if (process.env.NODE_ENV == "development") {
      console.log(process.env.NODE_ENV + "环境，可以显示全部按钮");
      data.btnListOfSqm = [
        {code:"mkhl_STQmbqd_mbqd_DC",name:h_i18n('55405ea6ff6fd823ffab7e6b10ddfa95')},
        {code:"mkhl_STQmbqd_mbqd_MBQD",name:h_i18n('c3d7d98d03ef74edd22fbc72848f3a23')}
      ]
    }
  }
  // searchTemp.month = new Date();
  searchTemp.year = new Date();
  date(searchTemp.year,'year')
  // date(searchTemp.month,'month')
  clearAll(true)
  // getClassCodeList()
  getSqeNodeList()
  getEcoList()
  getInfo();
})
onActivated(() => {
  if (data.keepalivestatus == 0) {
    console.log("首次打开");
    data.keepalivestatus ++
  } else {
    console.log("操作完之后打开");
      getInfo()
      proxy.postThisPageHeight();
    }
  })
  onDeactivated(() => {
    // console.log("keepalive-deactivated页面关闭时触发");
  })
</script>

<style lang="scss">
.ecologyTargetSignedList_style {
  .planHidden {
    display: none;
  }
}
</style>